// Charges du routeur Realtime (migration 20261013101000) :
//   ligne : {op, record, old_record} — l'id métier est record.id ;
//   ping  : {op, table, id, match_id?, league_id?, official_id?} — DELETE et
//           sujets de l'ancienne ligne seulement ; instruction « admin » : {op, table}.
// realtime.send ajoute son propre `id` aux charges qui n'en ont pas : sur une
// ligne (et sur un ping d'instruction), payload.id n'est PAS un id de ligne.
export type ChangeOp = 'INSERT' | 'UPDATE' | 'DELETE';

export const STATEMENT_TABLES = ['officials', 'official_emails', 'players', 'leagues', 'app_settings_versions', 'locations', 'mission_order_batches'] as const;

export interface RowChange {
    kind: 'row';
    op: ChangeOp;
    record: Record<string, unknown>;
    oldRecord: Record<string, unknown> | null;
}

export interface PingChange {
    kind: 'ping';
    op: ChangeOp | null;
    table: string | null;
    id: string | null;
    matchId: string | null;
    leagueId: string | null;
    officialId: string | null;
}

export type Change = RowChange | PingChange;

const OPS: readonly string[] = ['INSERT', 'UPDATE', 'DELETE'];

const isRecord = (v: unknown): v is Record<string, unknown> =>
    typeof v === 'object' && v !== null && !Array.isArray(v);
const text = (v: unknown): string | null => (typeof v === 'string' && v.length > 0 ? v : null);
const opOf = (v: unknown): ChangeOp | null => (typeof v === 'string' && OPS.includes(v) ? (v as ChangeOp) : null);

export function parseChange(payload: unknown): Change {
    const p = isRecord(payload) ? payload : {};
    const op = opOf(p.op);
    if (op && op !== 'DELETE' && isRecord(p.record) && text(p.record.id)) {
        return { kind: 'row', op, record: p.record, oldRecord: isRecord(p.old_record) ? p.old_record : null };
    }
    const table = text(p.table);
    const isStatementTable = table !== null && STATEMENT_TABLES.includes(table as any);
    return {
        kind: 'ping',
        op,
        table,
        id: isStatementTable ? null : text(p.id),
        matchId: text(p.match_id),
        leagueId: text(p.league_id),
        officialId: text(p.official_id),
    };
}
